'use strict';

module.exports = (element, index) => index;